/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from './investors-table.module.scss';
import { useTranslation } from 'next-i18next';
import { ISecFillingEntry } from '@anghami/neogateway/dist/endpoints/getSecFilings';

interface IProps {
	rows: ISecFillingEntry[];
}

export default function InvestorsTable({ rows }: IProps) {
	const { t } = useTranslation();
	return (
		<TableContainer style={{ background: 'unset', boxShadow: 'unset' }} component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="rss table">
				<TableHead>
					<TableRow>
						<TableCell className={`${styles.tableCell} ${styles.headerCell}`}>
							{t('IR_landing_date')}
						</TableCell>
						<TableCell className={`${styles.tableCell} ${styles.headerCell}`}>
							{t('IR_landing_filing_type')}
						</TableCell>
						<TableCell className={`${styles.tableCell} ${styles.headerCell}`}>
							{t('IR_landing_filing_description')}
						</TableCell>
						<TableCell className={`${styles.tableCell} ${styles.headerCell}`} />
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.length > 0 ? (
						rows.map((row, index) => (
							<TableRow
								key={row.entry_id + '-' + index}
								sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
							>
								<TableCell className={styles.tableCell} component="th" scope="row">
									{row.filing_date}
								</TableCell>
								<TableCell className={styles.tableCell}>{row.title}</TableCell>
								<TableCell className={styles.tableCell}>{row.summary}</TableCell>
								<TableCell className={styles.tableCell}>
									<a
										className={styles.downloadIcon}
										href={row.link}
										target="_blank"
										rel="noreferrer"
									>
										{t('IR_landing_download_view')}
									</a>
								</TableCell>
							</TableRow>
						))
					) : (
						<TableRow className="flexbox centered">
							<TableCell>Loading...</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
